import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import '../css/Layout.css';

const Layout = ({ children, onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="dashboard">
      <Header onMenuToggle={toggleSidebar} onLogout={onLogout} />
      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      
      {/* Overlay for mobile */}
      {sidebarOpen && <div className="sidebar-overlay" onClick={closeSidebar}></div>}

      {/* Main Content */}
      <main className="dashboard-main">
        {children}
      </main>
    </div>
  );
};

export default Layout; 